import * as R from 'ramda';

const parseToJsonAndUpdateDefaultFilters = store => (state, response) => {
    const { id, filterJson } = response;
    const parsedFilterJson = JSON.parse(filterJson);

    return R.evolve(
        {
            filters: {
                userDefaultFilters: {
                    id: R.always(id),
                    filterJson: R.always(parsedFilterJson),
                },
            },
        },
        store.getState(),
    );
};

export default parseToJsonAndUpdateDefaultFilters;
